import { LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { DebugService } from '@services/debug.service';
import { style } from './loading-spinner.style';

@customElement('refi-loading-spinner')
export class RefiLoadingSpinner extends LitElement {
  @property({ attribute: false })
  debug = new DebugService('LoadingSpinner');

  @property({ attribute: true })
  message: string = '';

  static styles = [style];

  render() {
    this.debug.log('rendered');
    return html`
      <div class="grv-spinner">
        ${this.message
          ? html`
              <span aria-label="${this.message}" role="alert"
                >${this.message}</span
              >
            `
          : ''}
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'refi-loading-spinner': RefiLoadingSpinner;
  }
}
